<script setup lang="ts">
// ================================
// PROPS & EMITS
// ================================
defineProps<{
    /** Titre affiché sous le logo (ex. "Bienvenue sur {companyName}"). */
    title: string
    /** Sous-titre optionnel (ex. "Connectez-vous à votre compte"). */
    subtitle?: string
}>()
</script>

<template>
    <!-- ================================ -->
    <!-- EN-TÊTE AUTH (LOGO + TITRE + SOUS-TITRE) -->
    <!-- ================================ -->
    <div class="flex flex-col justify-center items-center gap-4">
        <BaseScopeLogo width="240" height="auto" />
        <h2 class="text-semibold text-xl text-primary-700">
            {{ title }}
        </h2>
        <p v-if="subtitle" class="text-lg font-medium text-center">
            {{ subtitle }}
        </p>
    </div>
</template>
